import styled from "styled-components";

export const View = styled.div`
  flex: 3;
  padding: 1em;
  border: 1px solid black;
`;
